<div class="container">
    <article>
      <header>
        <strong>Histórico</strong>
        <section>
          <div *ngIf="!isLoading">
            <span>{{ totalItems }} resultado(s)</span>
          </div>
          <app-icon-button
            icon="assets/icons/refresh.svg"
            [color]="ButtonColorEnum.primary"
            [loading]="isLoading"
            (clickFunc)="getDetail()"
          ></app-icon-button>
          <app-secondary-button
            label="Voltar"
            [color]="ButtonColorEnum.common"
            (clickFunc)="return()"
          ></app-secondary-button>
        </section>
      </header>
      <main>
        <app-incidents-import-detail-header></app-incidents-import-detail-header>
        <ng-container *ngIf="isLoading">
          <div *ngFor="let i of [1, 2, 3, 4, 5]" class="skeleton">
            <div class="skeleton-column">
              <div class="skeleton-item"></div>
            </div>
          </div>
        </ng-container>
        <app-incidents-import-detail-item
          *ngFor="let import of imports"
          [data]="import"
        ></app-incidents-import-detail-item>
        <app-paginator
          [page]="page"
          [totalPages]="totalPages"
          [elementsShowing]="imports.length"
          [totalElements]="totalItems"
          (selectPageFunc)="handleSelectPage($event)"
        ></app-paginator>
      </main>
    </article>
  </div>
  